import React from "react";
import "./Contact.css";
import { Col, Row, Button, Form, Input, Alert, Checkbox, Modal } from "antd";
import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import {
  MailOutlined,
  HomeOutlined,
  UserOutlined,
  PhoneOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { addContact } from "../../../Actions/api";
import NotNeedAuthService from "../../../Services/notNeedAuth.service";
import TermAndCondition from "./TermAndConditionModal";
import useRecaptcha from '../../../hooks/useRecaptcha';
import { GET_RECAPTCHA_SITE_KEY } from "../../../Actions/types";

function Contact() {
  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { message } = useSelector((state) => state.message);
  const { TextArea } = Input;
  const [categoryName, setCategoryName] = useState([]);
  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const { executeRecaptcha } = useRecaptcha(GET_RECAPTCHA_SITE_KEY);

  const getAPIProductNameList = () => {
    var categoryList = [];

    NotNeedAuthService.getAPIProductNameList().then((response) => {
      for (var i = 0; i <= response.data.length - 1; i++) {
        categoryList.push({
          id: response.data[i].id,
          nameCategory: response.data[i].name,
        });
      }
      setCategoryName(categoryList);
    });
  };
  useEffect(() => {
    getAPIProductNameList();
  }, []);

  const onChange = (checkedValues) => {
    console.log(checkedValues.toString());
  };

  const onCheckboxChange = async (e) => {
    await setChecked(e.target.checked);
    form.validateFields(["checkTerm"]);
  };

  const validation = (rule, value, callback) => {
    if (checked) {
      return callback();
    }
    return callback("Please accept the terms and conditions");
  };

  const onFinish = async () => {
    const values = await form.validateFields();
    if (values) {
      setLoading(true);
    }
    const recaptchaToken = await executeRecaptcha('submit_form');
    dispatch(
      addContact(
        values.email,
        values.companyName,
        values.clientName,
        values.phoneNumber,
        values.purpose,
        values.apiCategories.toString(),
        values.registrationNumber,
        recaptchaToken
      )
    )
      .then(() => {
        setLoading(false);
        form.resetFields();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (message !== undefined) {
      try {
        if (message[0] === true) {
          setHidden(true);
        }
      } catch {
        setHidden(false);
      }
    }
  }, [message]);

  const option = categoryName.map((value) => (
    <Col xs={24} sm={24} md={24} lg={12} xl={8} key={value.id}>
      <Checkbox value={value.id}>{value.nameCategory}</Checkbox>
    </Col>
  ));

  return (
    <div className="contact-container">
      <div className="contact-title" hidden={hidden}>
        <FormattedMessage id="Contact Us" />
      </div>

      <br />
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          {message && (
            <div>
              {message[0] === true ? (
                <>
                  <h1 className="successRegister">
                    Thank you for contacting us. <br />
                    We'll contact you within a few working days.
                  </h1>
                  <p style={{ textAlign: "center" }}>
                    <br />
                    Redirect Back to <Link to="/">Home</Link> Page
                  </p>
                </>
              ) : (
                <Alert
                  message={
                    message[1] != null ? (
                      message[1]
                    ) : (
                      <ul style={{ paddingLeft: "20px" }}>
                        {message[2].map((m) => (
                          <li key={m}>{m}</li>
                        ))}
                      </ul>
                    )
                  }
                  type="error"
                />
              )}
            </div>
          )}
        </Col>
      </Row>
      <Form layout={formLayout} form={form} hidden={hidden}>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} justify="center">
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ]}
            >
              <Input addonBefore={<MailOutlined />} placeholder="Email" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} justify="center">
            <Form.Item
              label="Company Name"
              name="companyName"
              rules={[
                {
                  required: true,
                  message: "Please input your Company Name!",
                },
              ]}
            >
              <Input
                addonBefore={<HomeOutlined />}
                placeholder="Company Name"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} justify="center">
            <Form.Item
              label="Client Name"
              name="clientName"
              rules={[
                {
                  required: true,
                  message: "Please input your Client Name!",
                },
              ]}
            >
              <Input addonBefore={<UserOutlined />} placeholder="Your Name" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12} justify="center">
            <Form.Item
              label="Phone Number"
              name="phoneNumber"
              rules={[
                {
                  pattern: new RegExp(/^[0-9]+$/),
                  message: "Invalid Phone Number Input!",
                },
                {
                  required: true,
                  message: "Please input your Phone Number!",
                },
              ]}
            >
              <Input
                addonBefore={<PhoneOutlined />}
                placeholder="Phone Number"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              label="Registration Number"
              name="registrationNumber"
              rules={[
                {
                  required: true,
                  message: "Please input your registration number",
                },
              ]}
            >
              <Input
                addonBefore={<HomeOutlined />}
                placeholder="Registration Number"
              ></Input>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item
              label="Purpose of Having API"
              name="purpose"
              rules={[
                {
                  required: true,
                  message: "Please state your reason!",
                },
              ]}
            >
              <TextArea rows={3} showCount maxLength={250} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Api Categories"
          name="apiCategories"
          rules={[
            {
              required: true,
              validator: (_, value) =>
                value && value.length > 0
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error(
                        "Please select at least one or more of API Product Category"
                      )
                    ),
            },
          ]}
        >
          <Checkbox.Group style={{ width: "100%" }} onChange={onChange}>
            <Row gutter={[16, 24]}>{option}</Row>
          </Checkbox.Group>
        </Form.Item>

        <Form.Item
          style={{ marginTop: "35px", marginBottom: "20px" }}
          name="checkTerm"
          rules={[
            {
              validator: validation,
            },
          ]}
        >
          <Checkbox checked={checked} onChange={onCheckboxChange}>
            <label>
              I hereby declare that I am an duly authorized representative and
              any entity I may represent in connection with my use of Etiqa API
              Portal.{" "}
              <span className="hoverSpan" style={{ color: "#1890ff" }} onClick={() => setOpen(true)}>
                Terms and Conditions of Use
              </span>
            </label>
          </Checkbox>
        </Form.Item>

        <Modal
          title="Terms And Conditions"
          centered
          visible={open}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
          width={1000}
          footer={[
            <Button key="submit" type="primary" onClick={() => setOpen(false)}>
              Ok
            </Button>,
          ]}
        >
          <TermAndCondition />
        </Modal>

        <Row justify="center">
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              onClick={onFinish}
              size="large"
              className="button_login"
              disabled={loading}
            >
              {loading && <LoadingOutlined />}
              Submit
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default Contact;
